import InputBtn from './component-lib.esm.js';

//
var script = {
  name: 'IconInputBtn',
  components: {
    InputBtn
  },
  props: {
    ...InputBtn.props
  },
  setup() {
    return {};
  }
};
export { script as default };